export default class apiErrors {

    static getErrorMessage(error) {
        if (typeof error.response === 'undefined') {
            return error.message;
        }

        const response = error.response;
        const data = response.data;

        if (response.status >= 500) {
            return 'Sorry! An internal error has occurred';
        }

        // Check for form validation errors
        if (data.hasOwnProperty('errors')) {
            let error = data.errors[ Object.keys(data.errors)[ 0 ] ];
            if (typeof error === 'string' ) {
                return error;
            }

            return error[ 0 ];
        }

        if (typeof data == 'object') {
            return data[ Object.keys(data)[ 0 ] ];
        }

        if (data.hasOwnProperty('message') && data.message.length > 0) {
            return data.message;
        }

        if (response.data === 404) {
            return 'Not Found';
        }

        if (typeof data === 'string') {
            return data;
        }

        return 'Sorry! An unknown error has occurred';
    }

}



// WEBPACK FOOTER //
// ./resources/js/utils/apiErrors.js